// High-level context the user is operating in.
//   'shop'     — POS / owner mode. App shell + full shop nav.
//   'customer' — Loyalty mode. Minimal customer home.
//
// Stored in localStorage (survives refresh, clears on logout).
// Separate from app-mode.ts which is the within-shop working/maintenance nav toggle.
export type UserContextMode = 'shop' | 'customer';

const KEY = 'easypos-context-mode';

export function getUserContextMode(): UserContextMode | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'shop' || v === 'customer') return v;
  } catch {
    /* private browsing */
  }
  return null;
}

export function setUserContextMode(mode: UserContextMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* ignore */
  }
}

export function clearUserContextMode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
